export default __webpack_public_path__ + "static/media/whatsapp-notification.4abed924.mp3";